"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MileagePage;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_bootstrap_typeahead_1 = require("react-bootstrap-typeahead");
require("react-bootstrap-typeahead/css/Typeahead.css");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_dom_1 = require("react-dom");
const react_router_dom_1 = require("react-router-dom");
const react_hook_form_1 = require("react-hook-form");
const FormContext_1 = require("../View/Modals/FormContext");
const BussinesObjectSelectors_1 = require("../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const vehiclesApi_1 = require("./vehiclesApi");
const PURPOSE_OPTIONS = ["spotkanie", "rada budowy", "tankowanie", "kontrola budowy", "zakupy"];
const GENERAL_CODE = "OGÓLNE";
function today() {
    return new Date().toISOString().slice(0, 10);
}
// Rozpoznawanie mowy (Web Speech API) - kierowca dyktuje cyfry. Mapujemy słowa-cyfry
// na cyfry i wyrzucamy resztę; obsługuje też przypadek gdy Chrome zwróci już cyfry.
const WORD_DIGIT = {
    zero: "0", jeden: "1", jedna: "1", dwa: "2", dwie: "2", trzy: "3",
    cztery: "4", pięć: "5", sześć: "6", siedem: "7", osiem: "8", dziewięć: "9",
};
const spokenToDigits = (t) => t.toLowerCase().split(/\s+/).map((w) => WORD_DIGIT[w] ?? w).join(" ").replace(/\D/g, "");
const SpeechRecognitionCtor = typeof window !== "undefined" &&
    (window.SpeechRecognition || window.webkitSpeechRecognition);
// Przycisk dyktowania: w spoczynku obrys, podczas nagrywania czerwony i pulsujący zamiast mylącego spinnera.
function VoiceButton({ active, onClick, hint, }) {
    return (react_1.default.createElement(react_bootstrap_1.Button, { variant: active ? "danger" : "outline-primary", className: "text-nowrap", onClick: onClick, title: active ? "Nagrywanie... kliknij, aby zatrzymać" : hint },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faMicrophone, beatFade: active })));
}
function MileagePage() {
    // Wybór pojazdu jako trasa (#/mileage/:vehicleId) - dzięki temu systemowy
    // przycisk "wstecz" wraca z formularza do listy pojazdów.
    const { vehicleId } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const [vehicles, setVehicles] = (0, react_1.useState)([]);
    const [loadingVehicles, setLoadingVehicles] = (0, react_1.useState)(true);
    const [listError, setListError] = (0, react_1.useState)("");
    // Komunikat po zapisie wpisu (ze stanu nawigacji z formularza). Czytany wprost
    // w renderze, więc jest już w DOM listy w chwili snapshotu View Transition -
    // wjeżdża razem z listą, zamiast "wyskakiwać" po animacji.
    const savedState = location.state;
    const savedMsg = savedState?.savedMsg ?? "";
    const savedSheetUrl = savedState?.sheetUrl;
    // Zapisane tankowanie niesie dane, z których powstaje wpis do zaliczek.
    const fuelOffer = savedState?.fuelOffer;
    // Auto renderujemy wprost w renderze (jak komunikat), by trafiło do snapshotu
    // View Transition. Odpoczywa poza ekranem, więc po animacji jest niewidoczne.
    const driveCar = !!savedState?.driveCar;
    (0, react_1.useEffect)(() => {
        document.title = "Kilometrówka";
    }, []);
    // Wyczyść stan historii, by odświeżenie strony (F5) nie pokazało komunikatu ponownie.
    (0, react_1.useEffect)(() => {
        if (savedMsg)
            window.history.replaceState({}, "");
    }, [location.key]);
    function loadVehicles() {
        setLoadingVehicles(true);
        (0, vehiclesApi_1.fetchVehicles)()
            .then(setVehicles)
            .catch(() => setListError("Nie udało się pobrać listy pojazdów."))
            .finally(() => setLoadingVehicles(false));
    }
    // Ładuje na wejściu i po powrocie do listy (świeży stan licznika po wpisie).
    (0, react_1.useEffect)(loadVehicles, [vehicleId]);
    // Manifest PWA (instalowalność) tylko na tej zakładce i tylko na urządzeniach
    // dotykowych (telefony/tablety) - żeby opcja "Zainstaluj aplikację" nie pojawiała
    // się na pozostałych ekranach ERP ani na desktopie.
    (0, react_1.useEffect)(() => {
        const isMobile = window.matchMedia("(pointer: coarse)").matches;
        if (!isMobile)
            return;
        const link = document.createElement("link");
        link.rel = "manifest";
        link.href = "manifest.webmanifest";
        document.head.appendChild(link);
        return () => {
            document.head.removeChild(link);
        };
    }, []);
    const selectedVehicle = vehicleId
        ? vehicles.find((v) => String(v.id) === vehicleId) ?? null
        : null;
    if (vehicleId) {
        if (selectedVehicle)
            return react_1.default.createElement(MileageForm, { vehicle: selectedVehicle });
        return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-3", style: { maxWidth: 640 } }, loadingVehicles ? (react_1.default.createElement("div", { className: "text-center py-5" },
            react_1.default.createElement(react_bootstrap_1.Spinner, null))) : (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "Nie znaleziono pojazdu."))));
    }
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-3", style: { maxWidth: 720 } },
        react_1.default.createElement("style", null, `
                ::view-transition-old(root) {
                    animation: 1500ms cubic-bezier(0.4, 0, 0.2, 1) both mileageSlideOut;
                }
                ::view-transition-new(root) {
                    animation: 1500ms cubic-bezier(0.4, 0, 0.2, 1) both mileageSlideIn;
                }
                @keyframes mileageSlideOut { to { transform: translateX(-100%); } }
                @keyframes mileageSlideIn { from { transform: translateX(100%); } }

                /* Auto: spoczywa poza ekranem (translateX(-120vw) = niewidoczne po animacji),
                   a w warstwie View Transition przejeżdża po wierzchu przez cały ekran. */
                .mileage-drive-car {
                    position: fixed;
                    top: 50%;
                    left: 0;
                    transform: translate(-120vw, -50%);
                    view-transition-name: mileage-car;
                    font-size: 7rem;
                    color: var(--bs-primary, #0d6efd);
                    filter: drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.15));
                    pointer-events: none;
                    z-index: 9999;
                }
                /* Animujemy zawartość (-new), nie grupę - grupa trzyma wyśrodkowanie w pionie,
                   a auto rusza względem swojej pozycji spoczynkowej (-120vw): 230vw..55vw
                   daje netto 110vw..-65vw, czyli przejazd z prawej za lewą krawędź - auto
                   znika całkiem poza ekranem, bez zatrzymania w połowie. */
                ::view-transition-new(mileage-car) {
                    animation: 1500ms cubic-bezier(0.4, 0, 0.2, 1) both mileageCarDrive;
                }
                @keyframes mileageCarDrive {
                    from { transform: translateX(230vw); }
                    to   { transform: translateX(55vw); }
                }
                @media (prefers-reduced-motion: reduce) {
                    ::view-transition-old(root),
                    ::view-transition-new(root),
                    ::view-transition-new(mileage-car) { animation-duration: 0.01ms; }
                }
            `),
        driveCar && (react_1.default.createElement("div", { className: "mileage-drive-car", "aria-hidden": true },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCarSide, flip: "horizontal" }))),
        react_1.default.createElement("h4", { className: "mb-3" }, "Kilometr\u00F3wka"),
        savedMsg && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success" }, savedSheetUrl ? (react_1.default.createElement("a", { href: savedSheetUrl, target: "_blank", rel: "noopener noreferrer", title: "Otw\u00F3rz arkusz kilometr\u00F3wki", className: "link-body-emphasis link-underline-opacity-25 link-underline-opacity-100-hover" }, savedMsg)) : (savedMsg))),
        fuelOffer && (react_1.default.createElement("div", { className: "d-grid mb-4" },
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", onClick: () => navigate("/pettyCash", {
                    state: { fuelFromMileage: fuelOffer },
                }) }, "Dodaj zaliczk\u0119 za to tankowanie"),
            react_1.default.createElement("div", { className: "small text-muted mt-1 text-center" }, "Otworzy formularz zaliczek z danymi tego tankowania."))),
        listError && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, listError),
        loadingVehicles && vehicles.length === 0 ? (react_1.default.createElement("div", { className: "text-center py-5" },
            react_1.default.createElement(react_bootstrap_1.Spinner, null))) : (react_1.default.createElement("div", { className: "d-flex flex-column gap-3" }, vehicles.map((v) => (react_1.default.createElement(react_bootstrap_1.Card, { key: v.id, className: "shadow-sm", role: "button", onClick: () => navigate(`/mileage/${v.id}`) },
            react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "d-flex justify-content-between align-items-center py-4 px-4" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "fs-3 fw-bold" },
                        v.brand,
                        v.model ? ` ${v.model}` : ""),
                    react_1.default.createElement("div", { className: "text-muted" }, v.plate)),
                react_1.default.createElement("div", { className: "text-end" },
                    react_1.default.createElement("div", { className: "small text-muted" }, "Stan licznika"),
                    react_1.default.createElement("div", { className: "fs-2 fw-bold" },
                        v.currentReading != null
                            ? v.currentReading.toLocaleString("pl-PL")
                            : "—",
                        " ",
                        "km"))))))))));
}
function MileageForm({ vehicle }) {
    const formMethods = (0, react_hook_form_1.useForm)({ mode: "onChange" });
    const { watch, setValue } = formMethods;
    // Wejście z zaliczek: paragon za paliwo już wpisany, a razem z nim data, auto
    // i stan licznika - formularz otwiera się gotowy do zapisania.
    const fuelFromPettyCash = (0, react_router_dom_1.useLocation)().state?.fuelFromPettyCash;
    const [date, setDate] = (0, react_1.useState)(fuelFromPettyCash?.entryDate || today());
    const [purposes, setPurposes] = (0, react_1.useState)(fuelFromPettyCash ? ["tankowanie"] : []);
    const [routeFrom, setRouteFrom] = (0, react_1.useState)("Brzeg");
    const [routeMid, setRouteMid] = (0, react_1.useState)("");
    const [routeTo, setRouteTo] = (0, react_1.useState)("Brzeg");
    const [startReading, setStartReading] = (0, react_1.useState)(vehicle.currentReading != null ? String(vehicle.currentReading) : "");
    const [endReading, setEndReading] = (0, react_1.useState)(fuelFromPettyCash?.odometerReading ?? "");
    const [fuelingDate, setFuelingDate] = (0, react_1.useState)("");
    const [fuelingReading, setFuelingReading] = (0, react_1.useState)("");
    // Pola tankowania śledzą wartości domyślne (końcowy/data), dopóki użytkownik
    // ich ręcznie nie zmieni - inaczej wpisywanie końcowego cyfra po cyfrze
    // blokowałoby stan tankowania na pierwszej cyfrze.
    const [fuelingReadingTouched, setFuelingReadingTouched] = (0, react_1.useState)(false);
    const [fuelingDateTouched, setFuelingDateTouched] = (0, react_1.useState)(false);
    // Które pole aktualnie nagrywa (np. "reading", "dest") - null gdy cisza.
    const [listeningField, setListeningField] = (0, react_1.useState)(null);
    const recognitionRef = (0, react_1.useRef)(null);
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)("");
    const selectedContracts = watch("_contracts") ?? [];
    const driverPerson = watch("_driver");
    const driver = driverPerson ? `${driverPerson.name} ${driverPerson.surname}` : "";
    const isFueling = purposes.includes("tankowanie");
    const navigate = (0, react_router_dom_1.useNavigate)();
    // Zaliczki są modułem firmowym: kierowca spoza ENVI dostałby z nich odmowę,
    // więc propozycja paragonu ma się dla niego w ogóle nie pokazać.
    const canUsePettyCash = MainSetupReact_1.default.isRoleAllowed(MainSetupReact_1.default.STAFF_ROLES);
    // Telefon/tablet lub zainstalowana aplikacja.
    const isTouchOrApp = (0, react_1.useMemo)(() => window.matchMedia("(pointer: coarse)").matches ||
        window.matchMedia("(display-mode: standalone)").matches, []);
    // Przełącznik "Pełny formularz" (tylko mobile) pozwala wymusić widok jak na desktopie.
    const [showFullForm, setShowFullForm] = (0, react_1.useState)(false);
    // Uproszczony widok: kontrakt, trasa (skąd/dokąd), stan początkowy, data, kierowca
    // i pola tankowania ukryte - wysyłane są wartości domyślne (pusty kontrakt,
    // Brzeg-...-Brzeg, poprzedni licznik, dziś, zalogowany użytkownik jako kierowca).
    const simplified = isTouchOrApp && !showFullForm;
    // Switch "Pełny formularz" pokazuje się z napisem, po 5s zwija się do samego
    // suwaka (napis "zjadany" przez zwijający się kontener).
    const [switchCollapsed, setSwitchCollapsed] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!isTouchOrApp)
            return;
        const t = setTimeout(() => setSwitchCollapsed(true), 5000);
        return () => clearTimeout(t);
    }, [isTouchOrApp]);
    // Podpowiedź trasy (3 pola, edytowalne). Backend złoży je w "skąd - przez - dokąd".
    // "przez": miasto kontraktu ma pierwszeństwo (nawet przy tankowaniu); w przeciwnym
    // razie "Brzeg" dla tankowania, a puste dla reszty (backend zwinie do "Brzeg").
    // Miasta wszystkich wybranych kontraktów (bez powtórzeń) - string, więc nadaje się
    // na zależność efektu (tablica z watch() jest nowa przy każdym renderze).
    const contractCities = [
        ...new Set(selectedContracts.map((contract) => contract._city?.name).filter(Boolean)),
    ].join(" - ");
    (0, react_1.useEffect)(() => {
        setRouteFrom("Brzeg");
        setRouteTo("Brzeg");
        setRouteMid(contractCities || (isFueling ? "Brzeg" : ""));
    }, [contractCities, isFueling]);
    // Domyślne dane tankowania: stan = końcowy, data = data wyjazdu - dopóki
    // użytkownik ręcznie nie zmieni pola. Po odznaczeniu tankowania - reset.
    (0, react_1.useEffect)(() => {
        if (isFueling) {
            if (!fuelingReadingTouched)
                setFuelingReading(endReading);
            if (!fuelingDateTouched)
                setFuelingDate(date);
        }
        else {
            setFuelingReadingTouched(false);
            setFuelingDateTouched(false);
        }
    }, [isFueling, endReading, date, fuelingReadingTouched, fuelingDateTouched]);
    const km = (0, react_1.useMemo)(() => {
        const s = Number(startReading);
        const e = Number(endReading);
        if (!startReading || !endReading || Number.isNaN(s) || Number.isNaN(e))
            return null;
        return e - s;
    }, [startReading, endReading]);
    function purposeText() {
        // Brak wybranego celu = domyślnie "spotkanie".
        return purposes.length ? purposes.join(", ") : "spotkanie";
    }
    // Zwolnij mikrofon przy opuszczeniu formularza (gdyby sesja jeszcze trwała).
    (0, react_1.useEffect)(() => {
        return () => recognitionRef.current?.abort();
    }, []);
    // Klik w mikrofon danego pola: gdy cokolwiek nagrywa - zatrzymaj, inaczej zacznij nasłuch.
    function toggleVoice(field, onText) {
        if (listeningField) {
            recognitionRef.current?.stop();
            return;
        }
        startVoice(field, onText);
    }
    // Kierowca dyktuje wartość pola - transkrypt oddajemy do onText (cyfry albo miasto).
    function startVoice(field, onText) {
        if (!SpeechRecognitionCtor) {
            setError("Rozpoznawanie mowy niedostępne w tej przeglądarce.");
            return;
        }
        setError("");
        const rec = new SpeechRecognitionCtor();
        recognitionRef.current = rec;
        rec.lang = "pl-PL";
        rec.interimResults = false;
        rec.maxAlternatives = 1;
        rec.onresult = (e) => {
            onText(e.results[0][0].transcript);
            rec.stop(); // zwolnij mikrofon od razu (iOS Safari nie robi tego sam)
        };
        rec.onerror = (e) => {
            setListeningField(null);
            // 'aborted' = celowe przerwanie (stop/abort), nie pokazuj jako błąd.
            if (e?.error && e.error !== "aborted")
                setError(`Błąd mikrofonu: ${e.error}`);
        };
        rec.onend = () => setListeningField(null);
        try {
            setListeningField(field);
            rec.start();
        }
        catch (err) {
            setListeningField(null);
            setError("Nie udało się uruchomić mikrofonu - wymaga HTTPS/localhost i zgody.");
        }
    }
    // Transkrypt licznika: słowa-cyfry na cyfry, z komunikatem gdy nic nie rozpoznano.
    function fillReadingFromVoice(text) {
        const digits = spokenToDigits(text);
        if (digits)
            setEndReading(digits);
        else
            setError(`Nie rozpoznano liczby (usłyszano: "${text}").`);
    }
    function validate() {
        if (!routeMid.trim())
            return "Podaj miasto na trasie";
        if (!endReading)
            return "Podaj stan licznika końcowy.";
        if (!startReading)
            return "Brak stanu początkowego (poprzedni odczyt).";
        if (km != null && km < 0)
            return "Stan końcowy nie może być mniejszy od początkowego.";
        // Kierowca wymagany tylko w pełnym formularzu (na mobile fallback backendu).
        // Kontrakt jest opcjonalny - puste pole = OGÓLNE.
        if (!simplified && !driver.trim())
            return "Wybierz kierującego pojazdem.";
        return null;
    }
    async function handleSubmit() {
        const validationError = validate();
        if (validationError) {
            setError(validationError);
            return;
        }
        setError("");
        setSubmitting(true);
        try {
            const res = await fetch(`${MainSetupReact_1.default.serverUrl}mileage/trip`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    vehicleId: vehicle.id,
                    date,
                    driver,
                    // Uproszczony (mobile): puste. Pełny: kontrakty po przecinku
                    // (jedna komórka arkusza) lub OGÓLNE gdy nic nie wybrano.
                    projectOurId: simplified
                        ? ""
                        : selectedContracts
                            .map((contract) => contract.ourId)
                            .filter(Boolean)
                            .join(", ") || GENERAL_CODE,
                    purpose: purposeText(),
                    routeParts: [routeFrom, routeMid, routeTo],
                    startReading: Number(startReading),
                    endReading: Number(endReading),
                    fuelingDate: isFueling ? fuelingDate : "",
                    fuelingReading: isFueling && fuelingReading ? Number(fuelingReading) : "",
                }),
            });
            if (!res.ok)
                throw new Error("Nie udało się zapisać wpisu.");
            const trip = await res.json();
            const via = routeMid.trim();
            const savedMsg = `Zapisano wpis Lp. ${trip.lp} (${trip.km} km)${via ? ` przez ${via}` : ""}.`;
            // Po tankowaniu proponujemy zaliczkę, chyba że właśnie z niej przyszliśmy.
            const fuelOffer = isFueling && canUsePettyCash && !fuelFromPettyCash
                ? {
                    entryDate: fuelingDate || date,
                    vehicleId: vehicle.id,
                    odometerReading: fuelingReading || endReading,
                }
                : undefined;
            // Zapis potwierdzony. Przejście na listę robimy przez View Transitions API:
            // przeglądarka sama animuje wjazd listy i wyjazd formularza (bez białych ekranów),
            // a auto (osobny view-transition-name) przejeżdża po wierzchu.
            const startVT = document.startViewTransition?.bind(document);
            const goToList = () => navigate("/mileage", {
                state: {
                    savedMsg,
                    sheetUrl: vehicle.sheetUrl,
                    driveCar: !!startVT,
                    fuelOffer,
                },
            });
            if (startVT) {
                startVT(() => (0, react_dom_1.flushSync)(goToList));
            }
            else {
                goToList();
            }
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setSubmitting(false);
        }
    }
    const vehicleDisplayName = (react_1.default.createElement(react_1.default.Fragment, null,
        vehicle.brand,
        vehicle.model ? ` ${vehicle.model}` : "",
        !isTouchOrApp && ` · ${vehicle.plate}`));
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-3", style: { maxWidth: 640 } },
        react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mb-3" },
            react_1.default.createElement("h4", { className: "mb-0 text-truncate", style: { maxWidth: "70%" } }, vehicle.sheetUrl ? (react_1.default.createElement("a", { href: vehicle.sheetUrl, target: "_blank", rel: "noopener noreferrer", title: "Otw\u00F3rz arkusz kilometr\u00F3wki", className: "link-body-emphasis link-underline-opacity-25 link-underline-opacity-100-hover text-truncate d-inline-block" }, vehicleDisplayName)) : (vehicleDisplayName)),
            isTouchOrApp && (react_1.default.createElement("div", { title: "Pe\u0142ny formularz", className: "d-flex align-items-center", style: { gap: "0.5rem" } },
                react_1.default.createElement("span", { className: "small text-muted", style: {
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        maxWidth: switchCollapsed ? 0 : "10rem",
                        opacity: switchCollapsed ? 0 : 1,
                        transition: "max-width 0.7s ease, opacity 0.7s ease",
                    } }, "Pe\u0142ny formularz"),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", id: "mileage-full-form", className: "mb-0", checked: showFullForm, onChange: (e) => setShowFullForm(e.target.checked) })))),
        react_1.default.createElement(FormContext_1.FormProvider, { value: formMethods },
            react_1.default.createElement(react_bootstrap_1.Form, null,
                !simplified && (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Cel wyjazdu"),
                    react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: "mileage-purpose", multiple: true, allowNew: true, newSelectionPrefix: "Inne: ", options: PURPOSE_OPTIONS, selected: purposes, onChange: (sel) => setPurposes(sel.map((s) => (typeof s === "string" ? s : s.label))), placeholder: "Wybierz lub wpisz cel(e) wyjazdu..." }))),
                !simplified && (react_1.default.createElement("div", { className: "mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null,
                        "Kontrakty ENVI",
                        " ",
                        react_1.default.createElement("span", { className: "text-muted small" }, "(puste = OG\u00D3LNE)")),
                    react_1.default.createElement(BussinesObjectSelectors_1.ContractSelector, { name: "_contracts", typesToInclude: "our", showValidationInfo: false, multiple: true, limit: 5 }))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null,
                        "Opis trasy",
                        simplified ? "" : " (skąd - przez - dokąd)"),
                    simplified ? (
                    // Backend złoży "Brzeg - {to pole} - Brzeg"
                    react_1.default.createElement("div", { className: "d-flex gap-2" },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { value: routeMid, onChange: (e) => setRouteMid(e.target.value), placeholder: "Dok\u0105d" }),
                        SpeechRecognitionCtor && (react_1.default.createElement(VoiceButton, { active: listeningField === "dest", onClick: () => toggleVoice("dest", (t) => setRouteMid(t.trim())), hint: "Podyktuj miasto docelowe" })))) : (react_1.default.createElement(react_bootstrap_1.Row, { className: "g-2" },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { value: routeFrom, onChange: (e) => setRouteFrom(e.target.value), placeholder: "sk\u0105d" })),
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                            react_1.default.createElement("div", { className: "d-flex gap-2" },
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { value: routeMid, onChange: (e) => setRouteMid(e.target.value), placeholder: "przez" }),
                                SpeechRecognitionCtor && (react_1.default.createElement(VoiceButton, { active: listeningField === "dest", onClick: () => toggleVoice("dest", (t) => setRouteMid(t.trim())), hint: "Podyktuj miasto (przez)" })))),
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 3 },
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { value: routeTo, onChange: (e) => setRouteTo(e.target.value), placeholder: "dok\u0105d" }))))),
                react_1.default.createElement(react_bootstrap_1.Row, { className: "g-2 mb-3" },
                    !simplified && (react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Stan licznika pocz\u0105tkowy"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { inputMode: "numeric", value: startReading, onChange: (e) => setStartReading(e.target.value) }))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: simplified ? 12 : 6 },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Stan licznika ko\u0144cowy"),
                        react_1.default.createElement("div", { className: "d-flex gap-2" },
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { inputMode: "numeric", value: endReading, onChange: (e) => setEndReading(e.target.value) }),
                            SpeechRecognitionCtor && (react_1.default.createElement(VoiceButton, { active: listeningField === "reading", onClick: () => toggleVoice("reading", fillReadingFromVoice), hint: "Podyktuj cyfry stanu licznika" }))))),
                !simplified && (react_1.default.createElement(react_bootstrap_1.Row, { className: "g-2 mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data wyjazdu"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", value: date, onChange: (e) => setDate(e.target.value) })),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Ilo\u015B\u0107 km"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { value: km ?? "", readOnly: true, disabled: true })))),
                !simplified && isFueling && (react_1.default.createElement(react_bootstrap_1.Row, { className: "g-2 mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data tankowania"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", value: fuelingDate, onChange: (e) => {
                                setFuelingDate(e.target.value);
                                setFuelingDateTouched(true);
                            } })),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Licznik - tankowanie"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { inputMode: "numeric", value: fuelingReading, onChange: (e) => {
                                setFuelingReading(e.target.value);
                                setFuelingReadingTouched(true);
                            } })))),
                !simplified && (react_1.default.createElement("div", { className: "mb-3" },
                    react_1.default.createElement(BussinesObjectSelectors_1.RegisteringEditorSelector, { label: "Kieruj\u0105cy pojazdem", name: "_driver", fetchRoute: "mileage/drivers", showValidationInfo: false }))),
                error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error),
                react_1.default.createElement(react_bootstrap_1.Button, { className: "w-100", onClick: handleSubmit, disabled: submitting }, submitting ? react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm" }) : "Zapisz wpis")))));
}
